import { createContext } from 'react'

export const ChannelListContext = createContext({
  searchQuery: '',
  setSearchQuery: () => {},
  listTab: 'inbox',
  setListTab: () => {},
  inboxCount: 0,
  hiddenCount: 0,
})
